export default __webpack_public_path__ + "static/top2-24bf4ec18b5f2123472533232db11428.jpeg";